import { type ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useWorkOSAuth } from '../lib/auth';
import { appRoutes, publicRoutes } from '../lib/routes';

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  const { user } = useWorkOSAuth();

  return (
    <div className="public-site">
      <a href="#main-content" className="public-skip-link">
        Zum Inhalt springen
      </a>

      <header className="public-header">
        <Link to={publicRoutes.landing} className="public-brand" aria-label="HiT-App Startseite">
          <img src="/app-icon.png" alt="" className="public-brand-mark" />
          <span>HiT-App</span>
        </Link>

        <nav className="public-nav" aria-label="Öffentliche Navigation">
          <a href="/#funktionen">Funktionen</a>
          <a href="/#sicherheit">Sicherheit</a>
          <NavLink to={publicRoutes.help}>Hilfe</NavLink>
          <NavLink to={publicRoutes.privacy}>Datenschutz</NavLink>
        </nav>

        <div className="public-header-actions">
          <Link to="/demo" className="public-link-button">
            Demo anfragen
          </Link>
          <Link to={appRoutes.dashboard} className="btn btn-primary btn-sm">
            {user ? 'Zur App' : 'Anmelden'}
          </Link>
        </div>
      </header>

      <main id="main-content">{children}</main>

      <footer className="public-footer">
        <div className="public-footer-inner">
          <div>
            <Link to={publicRoutes.landing} className="public-footer-brand">
              HiT-App
            </Link>
            <p>Digitale Vereins- und Organisationskommunikation für geschlossene Netzwerke.</p>
          </div>
          <nav aria-label="Footer Navigation">
            <Link to={publicRoutes.help}>Hilfe</Link>
            <Link to={publicRoutes.privacy}>Datenschutz</Link>
            <Link to={appRoutes.dashboard}>App öffnen</Link>
            <a href="mailto:hit-app@hit.swiss">hit-app@hit.swiss</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
